import React, { FC } from 'react'
import { CheckBoxProps as Props } from './types'

const CheckBox: FC<Props> = ({ selected, onToggle }) => {
  return (
    <div
      className={ selected ? 'checkbox selected' : 'checkbox' }
      onClick={ () => onToggle() }
      role="presentation"
    >
      <div className="dot" />
    </div>
  )
}

export default CheckBox